import InternalStaticAnchor from 'models/application/anchor/types/internalStatic/InternalStatic';

export default class InternalStaticAnchorRankingList extends InternalStaticAnchor {
	/**
	 * @type {string}
	 * @private
	 */
	_pattern = '/ranking/list/:id?';
}
